import { AppHeadersService } from "./appHeaders.service";

export const AppHeadersServiceProvider = {
    provide: AppHeadersService
};
